import React, { useRef, useCallback, useState, useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Navbar } from "./Navbar";
import { Hero } from "./Hero";
import { About } from "./About";
import { Programs } from "./Programs";
import { WhyVLA } from "./WhyVLA";
import { Founders } from "./Founders";
import { Impact } from "./Impact";
import { Schedule } from "./Schedule";
import { Membership } from "./Membership";
import { Gallery } from "./Gallery";
import { Reviews } from "./Reviews";
import { FAQ } from "./FAQ";
import { Contact } from "./Contact";
import { Footer } from "./Footer";
import { Marquee, WhatsAppFloat, ScrollProgress } from "./shared";
import { CONTACT } from "../../lib/data";

const MARQUEE = ["Discipline", "Strength", "Respect", "Focus", "Victory", "Community"];

export const MarketingSite = () => {
  const lenisRef = useRef(null);
  const [prefill, setPrefill] = useState("");

  const onNav = useCallback((id) => {
    if (id === "home") { lenisRef.current?.lenis?.scrollTo(0, { duration: 1.2 }); return; }
    const el = document.getElementById(id);
    if (el) lenisRef.current?.lenis?.scrollTo(el, { offset: -68, duration: 1.2 });
  }, []);

  const onPlan = useCallback((planName) => {
    setPrefill(planName);
    setTimeout(() => onNav("contact"), 50);
  }, [onNav]);

  // If arriving with a hash (e.g. from a program page: /#contact), scroll to it
  useEffect(() => {
    const hash = window.location.hash?.slice(1);
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) lenisRef.current?.lenis?.scrollTo(el, { offset: -68 });
    }, 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.09, smoothWheel: true }}>
      <ScrollProgress />
      <Navbar onNav={onNav} />
      <main>
        <Hero onNav={onNav} />
        <div className="belt-divider" />
        <About />
        <div className="marquee-band"><Marquee items={MARQUEE} /></div>
        <Programs onNav={onNav} />
        <WhyVLA />
        <Founders />
        <Impact />
        <Schedule onNav={onNav} />
        <Membership onPlan={onPlan} onNav={onNav} />
        <Gallery />
        <Reviews />
        <FAQ />
        <Contact prefill={prefill} />
      </main>
      <Footer onNav={onNav} />
      <WhatsAppFloat href={`https://wa.me/${CONTACT.phoneRaw}`} />
    </ReactLenis>
  );
};
